import "@/App.css";
import { ReactLenis } from "lenis/react";
import Landing from "@/pages/Landing";
import { Toaster } from "@/components/ui/sonner";
import { AdminProvider } from "@/context/AdminContext";
import { LanguageProvider } from "@/context/LanguageContext";

function App() {
  return (
    <LanguageProvider>
      <AdminProvider>
        <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
          <div className="App">
            <Landing />
            <Toaster position="bottom-right" theme="dark" />
          </div>
        </ReactLenis>
      </AdminProvider>
    </LanguageProvider>
  );
}

export default App;
